module.exports = {
    quickReorder: {
        noProductMessage: 'No Products',
        quickReorderPageName: 'Buy Again!',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/quick-reorder.js